import { dataAndroid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAndroid = /*#__PURE__*/createIcon(dataAndroid)
export default IconAndroid
